import { Validators } from "@angular/forms";
import { FormatType } from "src/app/shared/components/summary/model/summary.model";
import { selectGender, selectTitle } from "src/app/shared/model/shared.model";
// tslint:disable:variable-name
export const CredentialModelForm = [
  {
    formatType: FormatType.text,
    label: "email",
    techname: "email",
    validators: [Validators.required],
    value: null,
  },
];

export interface Profile {
  birthdate: string;
  birthnation: string;
  birthplace: string;
  birthstate: string;
  birthregion: string;
  cod_status: number;
  corporateQuoterEnabled: boolean;
  customerId: number;
  customerIsRoot: boolean;
  customerName: string;
  email: string;
  first_name: string;
  id: number;
  identification: string;
  isConsumer: boolean;
  is_pool_driver: boolean;
  last_name: string;
  official_registration: string;
  pec: string;
  phone: string;
  phone_prefix: string;
  secondary_phone: string;
  secondary_phone_prefix: string;
  sex: string;
  status: string;
  title: string;
}

export const ProfileModelForm = [
  {
    formatType: FormatType.select,
    label: "title",
    techname: "title",
    validators: [Validators.required],
    select: selectTitle,
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "name",
    techname: "first_name",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "surname",
    techname: "last_name",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "gender",
    techname: "sex",
    validators: [Validators.required],
    select: selectGender,
    value: null,
  },
  {
    formatType: FormatType.date,
    label: "date_of_birth",
    techname: "birthdate",
    validators: [Validators.required],
    value: null,
  },

  {
    formatType: FormatType.select,
    label: "state_name",
    techname: "birthnation",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "province",
    techname: "birthregion",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "city",
    techname: "birthplace",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "fiscal_code",
    techname: "official_registration",
    validators: [
      Validators.required,
    ],
    value: null,
  },
];

export const PhoneModelForm = [
  {
    formatType: FormatType.select,
    label: "prefix",
    techname: "secondary_phone_prefix",
    //validators: [Validators.required],
    widthColumn: 7,
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "secondary_phone",
    techname: "secondary_phone",
    validators: [Validators.pattern(/^[0-9\-]*$/)],
    value: null,
  },
];

export const DocumentModelForm = [
  {
    formatType: FormatType.text,
    label: "driving_license_number",
    techname: "driving_license_number",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "driving_license_data_issue",
    techname: "driving_license_data_issue",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "driving_license_data_expiration",
    techname: "driving_license_data_expiration",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "driving_license_country",
    techname: "driving_license_country",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "driving_license_released",
    techname: "driving_license_released",
    validators: [Validators.required],
    value: null,
  },
];

export const AddressModelForm = [
  {
    formatType: FormatType.text,
    label: "street",
    techname: "street",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "zip_cod",
    techname: "zip_cod",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "province",
    techname: "province",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "city",
    techname: "city",
    validators: [Validators.required],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "state",
    techname: "state",
    validators: [Validators.required],
    value: null,
  },
];

export const AddressModelFmForm = [
  {
    formatType: FormatType.text,
    label: "street",
    techname: "street",
    validators: [],
    value: null,
  },
  {
    formatType: FormatType.text,
    label: "zip_cod",
    techname: "zip_cod",
    validators: [],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "province",
    techname: "province",
    validators: [],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "city",
    techname: "city",
    validators: [],
    value: null,
  },
  {
    formatType: FormatType.select,
    label: "state",
    techname: "state",
    validators: [],
    value: null,
  },
];

export interface ChangePasswordBody {
  oldPassword: "string";
  newPassword: "string";
}

export interface ChangePasswordAndMailResponse {
  content;
  error: any;
  message: string;
  result;
}

export class ProfileRequest {
  birthdate: string;
  birthnation: string;
  birthplace: string;
  birthregion: string;
  birthstate: string;
  cod_status: string;
  contract: string;
  corporateQuoterEnabled: boolean;
  customerId: string;
  customerIsRoot: boolean;
  customerName: string;
  customerReference: string;
  dataProtectionPolicyMarketing: boolean;
  dataProtectionPolicyThirdParty: boolean;
  dataProtectionPolicyTracking: boolean;
  driving_license: DrivingLicense;
  email: string;
  first_name: string;
  id: number;
  identification: string;
  isConsumer: boolean;
  is_pool_driver: boolean;
  last_name: string;
  main_address: MainAddress;
  official_registration: string;
  pec: null;
  phone: string;
  phone_prefix: string;
  policyPrivacyAcceptance: boolean;
  roles: Roles[];
  secondary_phone: string;
  secondary_phone_prefix: string;
  sex: string;
  status: string;
  title: string;
  secondary_phone_countryId: string;
  phone_countryId: string;
  city: string;
  state: string;
  zip_cod: string;
  street: string;
}

export interface DrivingLicense {
  number: string;
  issuing_country: string;
  valid_from: string;
  valid_to: string;
}

export interface Roles {
  roleId: string;
  roleName: string;
}

export interface MainAddress {
  city: string;
  province: string;
  region: string;
  state: string;
  state_name: string;
  street: string;
  street_nr: string;
  zip_cod: string;
}
